import { render, staticRenderFns } from "./EmailDragDrop.vue?vue&type=template&id=58d141cc&scoped=true&"
import script from "./EmailDragDrop.vue?vue&type=script&lang=js&"
export * from "./EmailDragDrop.vue?vue&type=script&lang=js&"
import style0 from "./EmailDragDrop.vue?vue&type=style&index=0&id=58d141cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d141cc",
  null
  
)

export default component.exports